export const reportsCommunication = {
  title: 'Reports Communication',
  notAvailable: 'N/A',
  scheduledReportsAlertTitle: 'Scheduled Reports',
  scheduledReportsAlertMessage: (dateTime: string) => `These reports are scheduled to go out on ${dateTime} (Eastern Time).`,
  tabs: {
    ready: 'READY',
    scheduled: 'SCHEDULED',
    sent: 'SENT',
    failed: 'FAILED'
  },
  actions: {
    remove: 'Remove',
    schedule: 'Schedule',
    unschedule: 'Unschedule',
    reschedule: 'Reschedule'
  },
  grid: {
    patientName: 'Patient Name',
    reportMonthYear: 'Report Month/Year',
    providers: 'Providers',
    providerDetails: 'Provider Details',
    preparedOn: 'Prepared On',
    scheduledOn: 'Scheduled On',
    failedOn: 'Failed On',
    status: 'Status',
    sentOn: 'Sent On',
    report: 'Report'
  },
  contactStatus: {
    success: 'Success',
    failed: 'Failed',
    resend: 'Resend',
    pending: 'Pending'
  },
  tooltips: {
    viewSummaryReport: 'View RPM Summary Report'
  },
  dialogs: {
    resendReportTitle: 'Resend RPM Report',
    resendReportMessage: (contactType: string) => `Are you sure you want to resend the RPM Report via ${contactType}?`,
    logTimeTitle: 'Log Time for Review',
    logTimeMessage: 'You’ve completed reviewing the report. Would you like to log your time now?',
    reportPreviewTitle: 'Rpm Report Preview',
    confirmScheduleTitle: 'Confirm Schedule RPM Reports',
    confirmUnscheduleTitle: 'Confirm Unschedule RPM Reports',
    confirmRemoveTitle: 'Confirm Remove RPM Reports',
    invalidOptionTitle: 'Invalid option selected for RPM Reports. Please try again.',
    confirmScheduleMessage: 'The selected reports will be scheduled for sending. Are you sure you want to proceed?',
    confirmUnscheduleMessage: 'The selected reports will be marked as ready for sending. Are you sure you want to proceed?',
    confirmRemoveMessage: 'The selected reports will be removed from ready for sending status. Are you sure you want to proceed?',
    invalidSubmissionMessage: 'Invalid submission of RPM Reports'
  },
  snackbars: {
    failedToSendReport: 'Failed to send RPM Report',
    couldNotFindContact: 'Could not find contact details to resend RPM Report.',
    failedToLoadPreview: 'Failed to load document preview',
    failedToUpdateReports: 'Failed to update RPM Reports',
    couldNotRemove: 'Could not remove RPM Reports statuses',
    couldNotSchedule: 'Could not schedule RPM Reports',
    couldNotUnschedule: 'Could not unschedule RPM Reports',
    couldNotReschedule: 'Could not reschedule RPM Reports',
    failedToRetrieveActivities: 'Failed to retrieve reports communications activities',
    failedToRetrieveCounts: 'Failed to retrieve reports counts'
  }
} as const;
